export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ14.604a2c2e.mp3";